import React from "react";
import { Field, useFormikContext } from "formik";
import { Textarea } from "../fields/Textarea";

import { Select } from "../fields/Select";
import { IBaseDetailsItem, IClient, IEmployee } from "../../core/cm.types";
import { DateField } from "../fields/DateField";
import 'react-tabs/style/react-tabs.css';
import { useTranslation } from "react-i18next";
import { Input } from "../fields/Input";
import { Checkbox } from "../fields/Checkbox";
import { ClientConsultantDropdown } from "../fields/ClientConsultantDropdown";
import MaskedInput from "react-text-mask";

export const AMMData: React.FunctionComponent<{ termination: IBaseDetailsItem[], employee: IEmployee[], isReadOnly: boolean, client: IClient }> = (props) => {
    const { t } = useTranslation();
    const { isReadOnly, client, termination, employee } = props;
    const { setFieldValue, values } = useFormikContext<any>();

    const statusOption = [{ key: "", text: t("client:tabAMM:statusOptions") }, ...termination?.map((item) => {
        return {
            key: item.key,
            text: item.title
        };
    })];

    const expenseMask = (value) => {
        const digits = (value || '').replace(/\D/g, '');
        if (digits.length === 0) return [/\d/, '.', /\d/, /\d/];
        
        const mask = [];
        const wholePartLen = digits.length <= 2 ? 0 : digits.length - 2;
        
        for (let i = 0; i < wholePartLen; i++) {
            mask.push(/\d/);
        }
        mask.push('.');
        mask.push(/\d/);
        mask.push(/\d/);
        
        return mask;
    };

    return (
        <React.Fragment>
            <ClientConsultantDropdown name="amm.administeredFrom" optionlabel={t("client:tabInterview:collaboratorOptions")} itemlabel={t("client:tabAMM:administeredFrom")} items={employee} isDisabled={isReadOnly} />
            <Field
                name="amm.number"
                label={t("client:tabAMM:number")}
                disabled={isReadOnly}
                type={"number"}
                max={999999999}
                min={0}
                component={Input}
            />
            <Field
                name="entry.date"
                disabled={isReadOnly}
                label={t("client:tabAMM:entryDate")}
                dateFormat="dd.MM.yyyy"
                selected={new Date(client?.entry?.date)}
                component={DateField}
            />
            <Field
                name="amm.assignmentExitDate"
                disabled={isReadOnly}
                label={t("client:tabAMM:assignmentExitDate")}
                dateFormat="dd.MM.yyyy"
                selected={new Date(client?.amm?.assignmentExitDate)}
                component={DateField}
            />
            <Field
                name="amm.terminationId"
                label={t("client:tabAMM:abandonment")}
                disabled={isReadOnly}
                options={statusOption}
                component={Select}
            />
            <Field
                name="amm.ammTermination"
                disabled={isReadOnly}
                label={t("client:tabAMM:ammTerminationDate")}
                dateFormat="dd.MM.yyyy"
                selected={new Date(client?.amm?.ammTermination)}
                component={DateField}
            />
            <Field
                name="amm.ammRemarks"
                label={t("client:tabAMM:ammRemarks")}
                disabled={isReadOnly}
                component={Textarea}
                maxLength={220}
            />
            <Field
                name="amm.remarks"
                label={t("client:tabAMM:remarks")}
                disabled={isReadOnly}
                component={Textarea}
                maxLength={500}
            />
            <div className="field">
                <label htmlFor="amm.transferCosts" className="label" style={{ display: "block" }}>
                    {t("client:tabAMM:transferCosts")}
                </label>
                <Field
                    name="amm.transferCosts"
                    disabled={isReadOnly}
                    component={Input}
                    render={({ field }) => (
                        <MaskedInput
                            {...field}
                            mask={expenseMask}
                            id="amm.transferCosts"
                            placeholder="123.22"
                            type="text"
                            disabled={isReadOnly}
                            className="input"
                        />
                    )}
                />
            </div>
            <div className="field">
                <label htmlFor="amm.flatrate" className="label" style={{ display: "block" }}>
                    {t("client:tabAMM:flatrate")}
                </label>
                <Field
                    name="amm.flatrate"
                    disabled={isReadOnly}
                    component={Input}
                    render={({ field }) => (
                        <MaskedInput
                            {...field}
                            mask={expenseMask}
                            id="amm.flatrate"
                            placeholder="123.22"
                            type="text"
                            disabled={isReadOnly}
                            className="input"
                        />
                    )}
                />
            </div>
            <Field
                name="amm.useFlatrate"
                label={t("client:tabAMM:useFlatrate")}
                component={Checkbox}
            />
            <br />
            <Field
                name="amm.noParticipation"
                label={t("client:tabAMM:noParticipation")}
                component={Checkbox}
            />
            <Field
                name="amm.correction"
                label={t("client:tabAMM:correction")}
                component={Checkbox}
            />
        </React.Fragment>
    );
};
